import React from "react";
import { Row, Col, Input, Select, Tooltip, Slider } from "antd";
import { ReactComponent as NoteIcon } from "@/assets/icons/note.svg";
import Utils from "@/utils";
import { useTranslation } from "react-i18next";

import "@/assets/toGIF.less";

const { Option } = Select;

const ToGIFWorkContentWorkRender = ({
  toGifObj,
  fps,
  framesRate,
  resolution,
  width,
  height,
  handleStartChange,
  handleEndChange,
  handleResolutionChange,
  handleRateChange,
  handleWidthChange,
  handleHeightChange,
  handleHeightFocus,
  handleWidthFocus,
  handleWidthBlur,
  handleHeightBlur,
}) => {
  const { t } = useTranslation(["toGIF"]);
  const marks = { 1: "1 FPS" };
  const nfps = fps < 15 ? fps : 15;
  marks[nfps] = nfps + " FPS";
  return (
    <div className="operation">
      <Row gutter={[16, 28]}>
        <Col span={12}>
          <span className="togit-label">{t("Start")}</span>
          <Input
            value={toGifObj ? toGifObj.start : "00:00.00"}
            onChange={handleStartChange}
            onBlur={() => Utils.handleBlurFormat("TOGIFOBJ_CHANGE", [{ ...toGifObj }], 0, "gif")}
          />
        </Col>
        <Col span={12}>
          <span className="togit-label">{t("End")}</span>
          <Input
            value={toGifObj ? toGifObj.end : "00:00.00"}
            onChange={handleEndChange}
            onBlur={() => Utils.handleBlurFormat("TOGIFOBJ_CHANGE", [{ ...toGifObj }], 0, "gif")}
          />
        </Col>
        <Col span={24}>
          <div className="select-cont">
            <span className="togit-label">{t("Resolution")}:</span>
            <Select className="dark-select" dropdownClassName="dark-select-dropdown" defaultValue={resolution} onChange={handleResolutionChange}>
              <Option value="origin">{t("Original")}</Option>
              <Option value="custom">{t("Custom")}</Option>
              <Option value="600:-1">600P*AUTO</Option>
              <Option value="540:-1">540P*AUTO</Option>
              <Option value="480:-1">480P*AUTO</Option>
              <Option value="360:-1">360P*AUTO</Option>
              <Option value="260:-1">260P*AUTO</Option>
              <Option value="100:-1">100P*AUTO</Option>
            </Select>
          </div>
        </Col>
        {resolution === "custom" ? (
          <Col span={11}>
            <Input value={width} onChange={handleWidthChange} onFocus={handleWidthFocus} onBlur={handleWidthBlur} />
          </Col>
        ) : null}
        {resolution === "custom" ? (
          <Col span={2} style={{ textAlign: "center" }}>
            <span>x</span>
          </Col>
        ) : null}
        {resolution === "custom" ? (
          <Col span={11}>
            <Input value={height} onChange={handleHeightChange} onFocus={handleHeightFocus} onBlur={handleHeightBlur} />
          </Col>
        ) : null}
        <Col span={24}>
          <div>
            <span>{t("Frame rate")}</span>
            <Tooltip placement="right" overlayClassName="gray" title={t("The higher the frame rate, the smoother the animation")}>
              <NoteIcon style={{ marginLeft: 10 }} />
            </Tooltip>
          </div>
        </Col>
        <Col span={24}>
          <Slider defaultValue={framesRate} min={1} max={nfps} marks={marks} onChange={handleRateChange} />
        </Col>
      </Row>
    </div>
  );
};

export default ToGIFWorkContentWorkRender;
